export default __webpack_public_path__ + "mediaelement-flash-video.27b385be.swf";